<template>
    <v-card color="#F5F2FB" flat class="rounded-0 pt-6">
        <v-container v-if="details">
            <!-- 顶部返回条 -->
            <div class="dc-topbar">
                <v-btn text small rounded color="#5A6270" @click="$router.back()">
                    <v-icon small class="mr-1">mdi-arrow-left</v-icon>
                    {{ $t('返回') }}
                </v-btn>
                <span class="dc-breadcrumb">{{ $t('模板中心') }} / {{ details.name }}</span>
            </div>

            <!-- 审核失败警示 -->
            <v-card flat class="dc-fail-card" v-if="details.themes_status == 3">
                <div class="dc-fail-head">
                    <v-icon color="#FF5252" size="22">mdi-alert-circle-outline</v-icon>
                    <span class="dc-fail-title">{{ $t('审核失败') }}</span>
                    <span class="dc-fail-sub">{{ $t('（审核失败请到原创作平台进行编辑后更新）') }}</span>
                </div>
                <div class="dc-fail-body">
                    <p class="dc-fail-label">{{ $t('失败原因') }}：</p>
                    <p class="dc-fail-text">{{ details.themes_status_text }}</p>
                    <div class="dc-fail-meta">
                        <span>{{ $t('申请时间') }}：{{ details.releasetime }}</span>
                        <span class="dc-fail-meta-gap">{{ $t('审核时间') }}：{{ details.audittime }}</span>
                    </div>
                </div>
            </v-card>

            <!-- 主内容 -->
            <v-row class="mt-4">
                <!-- 左：封面 + 描述 -->
                <v-col cols="12" lg="6">
                    <v-card flat class="dc-cover-card">
                        <div class="dc-cover-box">
                            <img :src="details.cover_img" alt="" class="dc-cover-img">
                        </div>
                        <div class="pa-5">
                            <p class="dc-desc">{{ details.des }}</p>
                        </div>
                    </v-card>
                </v-col>
                <!-- 右：信息 + 特点 + 操作 -->
                <v-col cols="12" lg="6">
                    <v-card flat class="dc-info-card pa-5">
                        <div class="dc-title-row">
                            <div class="dc-title-wrap">
                                <h2 class="dc-name">{{ details.name }}</h2>
                                <div class="dc-status">
                                    <v-chip small label color="rgba(138, 148, 166, 0.12)" class="grey--text text--darken-1"
                                        v-if="details.themes_status == 0">{{ $t('未发布') }}</v-chip>
                                    <v-chip small label color="rgba(115, 49, 255, 0.10)"
                                        v-if="details.themes_status == 1">{{ $t('已发布') }}</v-chip>
                                    <v-chip small label color="rgba(9, 187, 7, 0.10)" class="success--text"
                                        v-if="details.themes_status == 2">{{ $t('审核通过') }}</v-chip>
                                    <v-chip small label color="rgba(255, 34, 34, 0.10)" class="danger--text"
                                        v-if="details.themes_status == 3">{{ $t('审核失败') }}</v-chip>
                                </div>
                            </div>
                        </div>

                        <!-- 参数 -->
                        <div class="dc-params">
                            <div class="dc-param" v-if="details.version">
                                <span class="dc-param-label">{{ $t('当前版本号') }}</span>
                                <span class="dc-param-value">v{{ details.version }}</span>
                            </div>
                            <div class="dc-param" v-if="details.createtime">
                                <span class="dc-param-label">{{ $t('发表时间') }}</span>
                                <span class="dc-param-value">{{ details.createtime }}</span>
                            </div>
                            <div class="dc-param" v-if="details.updatetime">
                                <span class="dc-param-label">{{ $t('更新时间') }}</span>
                                <span class="dc-param-value">{{ details.updatetime }}</span>
                            </div>
                            <div class="dc-param">
                                <span class="dc-param-label">{{ $t('高分辨率') }}</span>
                                <span class="dc-param-value">{{ details.is_high_resolution == 1 ? $t('是的') : $t('不支持') }}</span>
                            </div>
                            <div class="dc-param" v-if="details.support_browsers">
                                <span class="dc-param-label">{{ $t('可兼容浏览器') }}</span>
                                <span class="dc-param-value">{{ details.support_browsers }}</span>
                            </div>
                            <div class="dc-param" v-if="details.layout">
                                <span class="dc-param-label">{{ $t('布局') }}</span>
                                <span class="dc-param-value">{{ details.layout }}</span>
                            </div>
                        </div>

                        <!-- 标签 -->
                        <div class="dc-tags" v-if="details.themes_tag_info && details.themes_tag_info.length">
                            <v-chip small outlined color="#7331FF" class="mr-1 mb-1"
                                v-for="item in details.themes_tag_info" :key="item.themes_tag_id">
                                {{ item.name }}
                            </v-chip>
                        </div>

                        <!-- 特点 -->
                        <div class="dc-features" v-if="details.features && details.features.length">
                            <p class="dc-features-title">{{ $t('主题模板特点') }}</p>
                            <div class="dc-feature-item" v-for="(fitem, fidx) in details.features" :key="fidx">
                                <v-icon size="16" color="#7331FF" class="mr-2">mdi-check-circle</v-icon>
                                <span>{{ fitem }}</span>
                            </div>
                        </div>

                        <!-- 操作 -->
                        <v-divider class="my-4"></v-divider>
                        <div class="dc-actions">
                            <v-btn color="#7331FF" dark depressed rounded class="px-8"
                                v-if="details.themes_status == 0"
                                @click="$router.push({ path: '/user-index', query: { publish_id: details.themes_id } })">
                                <v-icon small class="mr-1">mdi-upload</v-icon>
                                {{ $t('发布模版') }}
                            </v-btn>
                            <v-btn outlined rounded color="#FF5252" class="px-6" @click="askDelSelfmoban(details.themes_id)">
                                <v-icon small class="mr-1">mdi-delete-outline</v-icon>
                                {{ $t('删除当前模版') }}
                            </v-btn>
                        </div>
                    </v-card>
                </v-col>
            </v-row>

            <!-- 删除确认 -->
            <v-dialog v-model="delConfirm.show" max-width="420" persistent>
                <v-card class="pa-2">
                    <v-card-title class="text-h6">
                        <v-icon color="#FF5252" class="mr-2">mdi-delete-alert-outline</v-icon>
                        {{ $t('删除模板') }}
                    </v-card-title>
                    <v-card-text class="pt-0">
                        {{ $t('确定删除该模板吗？删除后不可恢复。') }}
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="delConfirm.show = false">{{ $t('取消') }}</v-btn>
                        <v-btn color="#FF5252" dark depressed rounded @click="confirmDelSelfmoban">
                            <v-icon small class="mr-1">mdi-delete</v-icon>
                            {{ $t('确认删除') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-container>
        <!-- 发布模板 -->
        <v-dialog v-model="selfObj.show" persistent width="450" attach="body">
            <v-card>
                <v-card-title class="text-h6">
                    <v-icon color="#faad14" class="mr-2">mdi-information-outline</v-icon>
                    {{ $t('发布模版') }}
                </v-card-title>
                <v-card-text>{{ $t('申请发布模版，TaoifyShop会尽快审核，请在个人中心查看结果。') }}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="selfObj.show = false">{{ $t('取消') }}</v-btn>
                    <v-btn color="primary" text @click="confirmSelf">{{ $t('确定') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
export default {
    data() {
        return {
            details: null,
            custom_themes_id: 0,
            delConfirm: { show: false, id: null },
            selfObj: {
                show: false,
                themes_id: 0
            }
        }
    },
    mounted() {
        this.custom_themes_id = this.$route.query.custom_themes_id;
        this.getdetail();

    },
    methods: {
        getdetail() {
            this.$api.template.themes_detail({ custom_themes_id: this.custom_themes_id }).then(res => {
                if (res.status) {
                    this.details = res.data;
                    if (res.data.type == 2) {
                        this.getpaytype();
                    }
                }
            })
        },
        getpaytype() {
            this.$api.template.paytype().then(res => {
                if (res.status) {
                    this.paylist = res.data;

                }
            })
        },
        openDialog(id) {
            this.selfObj.show = true;
            this.selfObj.themes_id = id;;
        },
        //发布模版
        confirmSelf() {
            this.$api.template.themes_release({ themes_id: this.selfObj.themes_id }).then(res => {
                this.selfObj.show = false;
                if (res.status) {
                    this.$Toast({ content: res.msg });
                    this.getdetail();
                } else {
                    this.$Toast({ content: res.msg, type: 'error' });
                }

            })
        },
        delSelfmoban(id) {
            this.$api.template.themes_del({ themes_id: id }).then(res => {
                if (res.status) {
                    this.$Toast({ content: res.msg });
                    this.$router.back();
                } else {
                    this.$Toast({ content: res.msg, type: 'error' });
                }
            })
        },
        // 删除确认
        askDelSelfmoban(id) {
            this.delConfirm.id = id;
            this.delConfirm.show = true;
        },
        confirmDelSelfmoban() {
            this.delConfirm.show = false;
            this.delSelfmoban(this.delConfirm.id);
        },
    }
}
</script>
<style lang="scss" scoped>
/* ===== 自定义模板详情页 ===== */
.dc-topbar {
    display: flex;
    align-items: center;
    margin-bottom: 18px;

    .dc-breadcrumb {
        font-size: 13px;
        color: #8A93A6;
        margin-left: 12px;
    }
}

.dc-fail-card {
    border-radius: 14px;
    border: 1px solid #FFD6D1;
    background: linear-gradient(135deg, #FFF5F3 0%, #FFEFEC 100%);
    overflow: hidden;
    margin-bottom: 18px;

    .dc-fail-head {
        display: flex;
        align-items: center;
        padding: 14px 20px;
        background: rgba(255, 82, 82, 0.06);
        border-bottom: 1px solid #FFE0DC;

        .dc-fail-title {
            font-size: 15px;
            font-weight: 700;
            color: #FF5252;
            margin-left: 8px;
        }

        .dc-fail-sub {
            font-size: 12px;
            color: #B0574F;
            margin-left: 10px;
        }
    }

    .dc-fail-body {
        padding: 16px 20px;

        .dc-fail-label {
            font-size: 13px;
            font-weight: 600;
            color: #5A6270;
            margin: 0 0 6px;
        }

        .dc-fail-text {
            font-size: 14px;
            color: #B0574F;
            line-height: 1.6;
            margin: 0;
        }

        .dc-fail-meta {
            margin-top: 14px;
            padding-top: 12px;
            border-top: 1px dashed #FFD6D1;
            font-size: 12px;
            color: #8A93A6;

            .dc-fail-meta-gap {
                margin-left: 28px;
            }
        }
    }
}

.dc-cover-card {
    border-radius: 14px;
    border: 1px solid #EEF1F5;
    overflow: hidden;
    box-shadow: 0 4px 16px rgba(15, 52, 96, 0.04);

    .dc-cover-box {
        background: #F8F9FC;
        padding: 18px;

        .dc-cover-img {
            width: 100%;
            border-radius: 10px;
            display: block;
            box-shadow: 0 8px 24px rgba(15, 52, 96, 0.08);
        }
    }

    .dc-desc {
        font-size: 14px;
        color: #4A5568;
        line-height: 1.8;
        margin: 0;
    }
}

.dc-info-card {
    border-radius: 14px;
    border: 1px solid #EEF1F5;
    box-shadow: 0 4px 16px rgba(15, 52, 96, 0.04);

    .dc-title-row {
        .dc-title-wrap {
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
            gap: 10px;

            .dc-name {
                font-size: 22px;
                font-weight: 800;
                color: #0F3460;
                margin: 0;
            }
        }
    }

    .dc-params {
        margin-top: 20px;
        background: #F8F9FC;
        border-radius: 12px;
        padding: 6px 16px;

        .dc-param {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 0;
            border-bottom: 1px dashed #E8ECF2;

            &:last-child {
                border-bottom: none;
            }

            .dc-param-label {
                font-size: 13px;
                color: #8A93A6;
            }

            .dc-param-value {
                font-size: 14px;
                color: #2E3A4E;
                font-weight: 600;
            }
        }
    }

    .dc-tags {
        margin-top: 16px;
    }

    .dc-features {
        margin-top: 20px;

        .dc-features-title {
            font-size: 15px;
            font-weight: 700;
            color: #0F3460;
            margin: 0 0 12px;
        }

        .dc-feature-item {
            display: flex;
            align-items: center;
            padding: 7px 0;
            font-size: 14px;
            color: #4A5568;
        }
    }

    .dc-actions {
        display: flex;
        gap: 12px;
        flex-wrap: wrap;

        .v-btn {
            text-transform: none;
        }
    }
}
</style>